import React, { Component } from 'react'
import { Link } from "react-router-dom";
import Modal from 'react-responsive-modal';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import QRCode from 'qrcode-react';
import AMLogo from '../../assets/images/audition-magic-favicon.png';

class ProjectLinkUrlModal extends Component {
	state = {
    linkValue: '',
    linkCopied: false,
  };


	render() {
		const {showProjectLinkModal, onCloseModal, currentProject } = this.props
		return(
			<Modal  
				classNames={{ modal: 'project-link-modal-overlay' }}
				open={showProjectLinkModal} 
				onClose={onCloseModal} little>
		    <div className="project-link-modal">

			    <p className="reveal-title">Project Check-in URL</p>

			    <div className="content">
					  <p>Copy this link below, to send via email to anyone wishing to login on their on device</p>
						
						<div className="row collapse">
							<div className="small-12 column">
								<div className="input-group">
								  <input type="text" 
								    disabled
								  	className="input-group-field" 
								  	onChange={({target: {value}}) => this.setState({linkValue: value, linkCopied: false})}
								  	value={currentProject && `${window.location.origin}/artist/login?project=${currentProject.id}`}
								  	placeholder="Public Link" />
								  <div className="input-group-button">
								  <CopyToClipboard text={currentProject && `${window.location.origin}/artist/login?project=${currentProject.id}`}
					          onCopy={() => this.setState({linkCopied: true})}>
					          <button className="button primary copy">Copy</button>
					        </CopyToClipboard>
								  </div>
								</div>		
							</div>
						</div>

						<div className="row collapse">
							<div className="small-12 column">
								<p>Via QR Code:</p>
								<div className="">

									{
										currentProject && <QRCode value={`${window.location.origin}/artist/login?project=${currentProject.id}`} size={256} logo={AMLogo} />
									}
								</div>
							</div>
						</div>
						{
							// <p className="lead">Or Send vai SMS Message to a phone</p>
							// <div className="row collapse">
							// 	<div className="small-4 column">
							// 		<select>
							// 			<option value="">Country</option>
							// 		    <option value="husker">Husker</option>
							// 		    <option value="starbuck">Starbuck</option>
							// 		    <option value="hotdog">Hot Dog</option>
							// 		    <option value="apollo">Apollo</option>
							// 		</select>
							// 	</div>
							// 	<div className="small-8 column">
							// 		<input type="text" placeholder="Mobile Number" />
							// 	</div>
							// </div>	
						}
					</div>


					<div className="modal-actions">
					  <a className="button hollow cancel float-left" onClick={onCloseModal}>Cancel</a>
					  <a className="button secondary proceed float-right">Send</a>
					</div>

				</div>
		  </Modal>
		)
	}
}

export default ProjectLinkUrlModal





// WEBPACK FOOTER //
// ./src/components/modals/ProjectLinkUrlModal.js